import { gql } from "@apollo/client";

export const AUTHORIZE_GSC = gql`
  query AuthorizeGsc {
    authorizeGsc {
      authorization_url
      state
    }
  }
`;

export const GET_GSC_AUTH_STATUS = gql`
  query GetGscAuthStatus($email: String) {
    gscAuthStatus(email: $email) {
      status
    }
  }
`;

export const GET_GSC_SITES = gql`
  query GetGscSites($email: String) {
    gscSites(email: $email) {
      success
      sites
      count
    }
  }
`;
